module.exports = __webpack_public_path__ + "static/media/6178E.b072e70d.jpg";